module.exports = __webpack_public_path__ + "img/text-align-middle-01.24bc4233.svg";